import { ToggleButton } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';

interface Props {
  selected: boolean;
  selectToday: () => void;
}

/** Shortcut next to a date field for setting it to today. */
export function TodayToggleButton({ selected, selectToday }: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <ToggleButton
      size="small"
      value="today"
      selected={selected}
      sx={{
        borderRadius: 5,
        flexShrink: 0,
        height: 34,
        '&.Mui-selected': {
          '&, &:hover': {
            color: 'common.white',
            backgroundColor: 'primary.main',
            borderColor: 'primary.main',
          },
          '&:hover': {
            backgroundColor: 'primary.light',
            borderColor: 'primary.light',
          },
        },
      }}
      onChange={selectToday}
    >
      {t('myAssortment.actions.today')}
    </ToggleButton>
  );
}
